export default __webpack_public_path__ + "static/media/hacktober.17157992.png";